module.exports = __webpack_public_path__ + "img/volume-off.a052d80b.svg";